module.exports = __webpack_public_path__ + "static/media/Icon404.86602bc3.svg";